export default "__VITE_ASSET__D2p37qGo__"